<template>
  <div class="date-dropdown">
    <PillDropdown
      :name="$t('search.dateDropdownName')"
      :options="dateState"
      :allow-multi-select="false"
      is-thin-dropdown-width
      @clear-filters="clearFilters"
      @apply-filters="applyFilters"
      @filter-applied="$emit('filterApplied', $event)"
    >
    </PillDropdown>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useSearchFilters } from '@/composables/useSearchFilters';
import PillDropdown from './PillDropdown.vue';
import { trackDateFilterApplied } from '@/helpers/searchAnalytics';

defineEmits(['filterApplied']);

const route = useRoute();
const { $t } = useNuxtApp();
const { dateState, initializeDateOptions, selectedDate } = useSearchFilters();

onMounted(() => {
  const today = new Date();

  const fullDateFormatter = new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  const formattedDateToday = fullDateFormatter.format(today);
  const formattedDateLast7Days = fullDateFormatter.format(today - 7 * 24 * 60 * 60 * 1000);
  const formattedDateLast30Days = fullDateFormatter.format(today - 30 * 24 * 60 * 60 * 1000);
  const currentYear = new Date().getFullYear();
  const lastYear = currentYear - 1;

  const dateOptions = [
    {
      name: $t('search.today'),
      idx: 0,
      start_date: formattedDateToday,
      end_date: formattedDateToday,
      checked: false,
      filterValue: 'today',
    },
    {
      name: $t('search.last7Days'),
      idx: 1,
      start_date: formattedDateLast7Days,
      end_date: formattedDateToday,
      checked: false,
      filterValue: 'last7Days',
    },
    {
      name: $t('search.last30Days'),
      idx: 2,
      start_date: formattedDateLast30Days,
      end_date: formattedDateToday,
      filterValue: 'last30Days',
    },
    {
      name: $t('search.thisYear'),
      idx: 3,
      start_date: `${currentYear}-01-01`,
      end_date: `${currentYear}-12-31`,
      filterValue: 'thisYear',
    },
    {
      name: $t('search.lastYear'),
      idx: 4,
      start_date: `${lastYear}-01-01`,
      end_date: `${lastYear}-12-31`,
      filterValue: 'lastYear',
    },
  ];
  initializeDateOptions(dateOptions);
});

function clearFilters() {
  const newQuery = { ...route.query };
  delete newQuery.start_date;
  delete newQuery.end_date;
  navigateTo({ query: newQuery }, { replace: true });
}

function applyFilters() {
  if (selectedDate.value?.filterValue) {
    trackDateFilterApplied(selectedDate.value.filterValue);
  } else {
    trackDateFilterApplied('custom');
  }

  const newQuery = { ...route.query, start_date: selectedDate.value.start_date, end_date: selectedDate.value.end_date };
  navigateTo({ query: newQuery }, { replace: true });
}
</script>
